module.exports = __webpack_public_path__ + "static/media/in_circle.51b4c738.svg";